import { Cohort, OptionValue } from 'root-constants'

export const QUESTIONS_MAP: Record<Cohort, Record<string, string>> = {
  [Cohort.VARIANT_ONE]: {
    feel_nervous: `I've been feeling nervous, anxious or on edge over the last two weeks`,
    daily_regime: 'I stay up late and go to bed after midnight',
    feel_tired: 'When I get up in the morning, I feel tired and overwhelmed',
    found_upset: 'I have found myself getting upset by quite trivial things',
    found_impatient: `I've found myself getting impatient if I've been delayed in any way`,
    unable_to_control: `I feel I'm unable to control the important things in my life`,
    feel_scared: 'I have felt scared or nervous for no good reason',
  },
  [Cohort.VARIANT_TWO]: {
    daily_regime: 'Do you stay up late and go to bed after midnight?',
    feel_tired:
      'Do you feel tired and overwhelmed, when you get up in the morning?',
    found_upset: 'Do you get upset by quite trivial things?',
    found_impatient: `I've found myself getting impatient if I've been delayed in any way`,
    unable_to_control: `I feel I'm unable to control the important things in my life`,
    feel_scared: 'I have felt scared or nervous for no good reason',
  },
}

export const DefaultOptions = [
  {
    id: '0',
    value: OptionValue.NOT_AT_ALL,
    key: 'onboarding.answers.not_at_all',
  },
  {
    id: '1',
    value: OptionValue.OCCASIONALLY,
    key: 'onboarding.answers.occasionally',
  },
  { id: '2', value: OptionValue.OFTEN, key: 'onboarding.answers.often' },
  {
    id: '3',
    value: OptionValue.VERY_MUCH_SO,
    key: 'onboarding.answers.very_much_so',
  },
]
